<div class="table mt-0125"
     [ngClass]="tableHighlightClass"
     *ngIf="activeFollowUp">
  <div class="tr tr--noGutter tile__heading pt-0025 pb-0025 pr-0025 flexWrap-nowrap">
    <span>
      <i class="fas fa-flag mr-0025 table--highlight-text"></i>
      Flagged by
      <!-- flag creator displays as fullname or "You" -->
      <span class="table--highlight-text"
            *ngIf="activeFollowUp.createdBy.id === currentUserId">You</span>
      <span class="table--highlight-text"
            *ngIf="activeFollowUp?.createdBy.id !== currentUserId">
        {{activeFollowUp.createdBy | fullName}}</span>
      <ng-container *ngIf="assignedUser?.id">
        <span> For</span>
        <span class="table--highlight-text"
              *ngIf="assignedUser?.id === currentUserId">
          You
        </span>
        <span class="table--highlight-text"
              *ngIf="assignedUser?.id !== currentUserId">
          {{assignedUser?.name}}
        </span>
      </ng-container>
      on {{activeFollowUp.createdAt | date:'MMM d, y h:mma'}}
    </span>
    <button aria-haspopup="true"
            class="popover__btn ml-auto"
            type="button"
            [matMenuTriggerFor]="flagMenu">
      <i class="far fa-fw fa-ellipsis-h fa--gray"></i>
    </button>

    <mat-menu class="popover__menu"
              #flagMenu="matMenu">
      <ul class="popover__list">
        <li class="popover__item">
          <button type="button" class="link link--gray"
             (click)="editNote(activeFollowUp)"
             aria-haspopup="dialog"
             *ngIf="canEditNote">Edit Note</button>
        </li>
        <li class="popover__item">
          <button type="button" class="link link--gray"
            (click)="editDueDate(activeFollowUp)"
            aria-haspopup="dialog">Edit Due Date</button>
        </li>
        <li class="popover__item">
          <button type="button" class="link link--gray"
              aria-haspopup="dialog"
             (click)="reassignFollowUp(activeFollowUp)">Reassign Flag</button>
        </li>
        <li class="popover__item">
          <button type="button" class="link link--red"
             aria-haspopup="dialog"
             (click)="completeFollowUpFlag()">Complete</button>
        </li>
      </ul>
    </mat-menu>
  </div>
  <div class="tr d-block bg-color--white pt-0100 pb-0100 pr-0100">
    <app-clipped-note [text]="activeFollowUp?.note?.text">
    </app-clipped-note>

    <div class="mt-0075 ml-0100neg mr-0100neg mb-0025neg pl-0100 pr-0100 border-1 border-left-0 border-bottom-0 border-right-0 pt-0062"
         *ngIf="activeFollowUp?.dueDate">
      <i class="far fa-hourglass txt-12 mr-0050"
         [ngClass]="dueDateTextClass"></i>
      <strong class="caps txt-12 mr-0025"
              [ngClass]="dueDateTextClass">Due {{dueDateEndOfDay | relativeDate}}</strong>
      <span class="color--gray caps txt-12">({{dueDateEndOfDay | date:'MMM d, y'}})</span>
    </div>
  </div>
  <!--<div class="tr tr--noGutter tile__heading"
       *ngIf="showFullText || activeFollowUp?.note?.text?.length < 76">
    <button type="button"
            class="mimic-link uppercase txt-13 txt-fw-500 color--red"
            (click)="completeFollowUpFlag()">
      <i class="far fa-check"></i><span class="ml-0025">Complete</span>
    </button>
  </div>-->
</div>
